import { render, staticRenderFns } from "./LotName.vue?vue&type=template&id=4b27c8d0&"
import script from "./LotName.vue?vue&type=script&lang=js&"
export * from "./LotName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b27c8d0')) {
      api.createRecord('4b27c8d0', component.options)
    } else {
      api.reload('4b27c8d0', component.options)
    }
    module.hot.accept("./LotName.vue?vue&type=template&id=4b27c8d0&", function () {
      api.rerender('4b27c8d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prize/lot/components/LotName.vue"
export default component.exports